import React from 'react'
import Header from '../../common/Header'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import CommonHeroSection from '../../common/CommonHeroSection'
import Footer from '../../common/Footer'
import TicketSection from '../../sections/CommonSection/TicketSection'
import carAndCoachRentalImg from '../../../assets/our-services-img/car-and-coach-rental-img.jpg';

const CarAndCoachRental = () => {
    return (
        <>
            <Header />
            <CommonHeroSection title="Car & Coach Rental" />
            <CommonBreadcrumb items={["Car & Coach Rental"]} />
            <TicketSection
                title="Car & Coach Rental"
                description={[
                    `To plan a successful tour, a traveller needs to remember so many aspects to avoid unnecessary inconvenience. Car & coach rental is indeed one among them that require immense experimentation. Oftentimes, most travellers find it difficult to book a car and motorist for numerous sightseeing purposes. But when the name is Sudarshan Holidays, there is no chance of any hurdle because we offer a faultless execution process of the entire car booking plan.`,
                    `Being one of the well-established travel agencies in Bangalore, Karnataka we offer comfortable yet cost-efficient cars for exploring miscellaneous tourist attractions of Bangalore, Karnataka. We can deliver highly comfortable cars like SUVs, MUVs, minivans, minicabs or any other car bookings of our client's preference. Apart from providing extraordinary car bookings, we can also deliver expert car coaches or motorists who possess excellent knowledge of car driving in several languages and tourist spots of Bangalore, Karnataka.`,
                    `Hence, call Sudarshan Holidays now to get an extraordinary car & coach rental service at highly reasonable rates.`
                ]}
                image={carAndCoachRentalImg}
            />
            <Footer />
        </>
    )
}

export default CarAndCoachRental
